import { useEffect } from "react";
import MembershipInfo from "../../components/membership/MembershipInfo";
import { useForm } from "react-hook-form";
import BookingPrivilege from "../../components/membership/BookingPrivilege";
import MembershipConfigurations from "../../components/membership/MembershipConfigurations";
import { useDispatch, useSelector } from "react-redux";
import { UserSliceType } from "../../lib/redux/slices/userSlice";
import {
  useCreateMembershipMutation,
  useEditMembershipMutation,
  useGetMembershipByIdQuery,
} from "../../lib/redux/services/sections/Customers";
import { useGetAllCourtsQuery } from "../../lib/redux/services/sections/Courts";
import MembershipBenefit from "../../components/membership/MembershipBenefit";
import Button from "../../components/global/Button";
import { toast } from "react-toastify";
import { toastMessage } from "../../utils/utils";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/skeletons/Loader";
import { MembershipRequest } from "../../types/request/membership";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { setFormIsDirty } from "../../lib/redux/slices/formSlice";
import ErrorSection from "../../components/global/ErrorSection";
import useBlocker from "../../hooks/useBlocker";

type Props = {
  data?: any;
};
const defaultData = {

            "trial": true,
            "trial_duration": 0,
            "auto_renew": true,
        
            "booking_days_in_advance": 0,
            "max_number_of_bookings_days": 0,
            "max_number_of_bookings_month": 0,    
            "max_duration_of_bookings_minutes_month": 0,
            "max_number_of_active_bookings": 0,
            "Welcome_pack": true,
            "Welcome_pack_desc": "",
            "number_of_duration": 0,
            "number_of_duration_unit": "Week", //Week or Month or Year
            "disabled-enabled": "",
             "status":"enabled",
            "joining_fee": 0,
            "billing_cycle": 0,
            "billing_cycle_per": "Week", //Week or Month or Year
            "availability_recurring": true,
            "pausable": true,
            "max_number_of_pausable_days": 0,
            "club_ids": [37],
            "court_ids": [],
            "service_ids": [],
            "application": "paid_amount", // paid_amount OR member_share
            "discount_type": "value", // value or "percentage"
            "discount": 0,

            "terms": ""
    }
type props= {
  type:'new'|'edit'|'view'|'duplicate'
}
function MembershipInfoOne({type='new'}:props) {
  const { shared }: DictionaryType = useGetDictionary();
    const selectedClub = useSelector((state: any) => state.user.selectedClub);
 
  useBlocker();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
    setValue,
    watch,
    trigger,
    getValues,
  } = useForm<MembershipRequest>({
    disabled:type === 'view',
    defaultValues: defaultData,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    if (isDirty) dispatch(setFormIsDirty(true));
    else dispatch(setFormIsDirty(false));
  }, [isDirty]);
  const param = useParams();
  const navigate = useNavigate();
  const [editMembership] = useEditMembershipMutation();
  // fetch membership data when id is available
  const {
    data: membershipData,
    isLoading: loadingMembership,
    isFetching,
    isSuccess,
    isError,
  } = useGetMembershipByIdQuery(param.id, {
    skip: !param.id,
  });
  // get all courts in club
  const clubId = useSelector((state: UserSliceType) => state.user.selectedClub);

  const { data, isLoading } = useGetAllCourtsQuery({ club_id: clubId });
  // create membership mutation
  const [createMembership] = useCreateMembershipMutation();
  // map courts to label and value
  const courts = data?.data?.map((court: { name: string; id: number }) => {
    return { label: court.name, value: court.id };
  });
  // submit membership form
  const onSubmit = async (data: MembershipRequest) => {
    try {
      // create final data object with club_ids, court_ids and service_ids
      const finalData = {
...defaultData,
        ...data,
        // club_ids: data?.club_ids?.map((club: any) => parseInt(club.id)),
        // court_ids: data?.court_ids?.map((court: any) => parseInt(court.id)),
        // service_ids: data?.service_ids?.map((service: any) =>
        //   parseInt(service.id)
        // ),
      };
      // if id is available, edit membership
      if (param.id && type === 'edit') {
        await toast.promise(
          editMembership({
            data: finalData,
            owner_club_id:selectedClub,
            id: param.id,
          }).unwrap().then((res)=>{
             console.log(res?.data?.data?.id);
             navigate(`/club-settings/membership/step2/edit/${param?.id}`)
          }),
          toastMessage()
        );
        // if id is not available, create membership
      } else {
        await toast.promise(
          createMembership({
            data: finalData,
            owner_club_id:selectedClub
          }).unwrap().then((res)=>{
            console.log(res?.data);
            
             navigate(`/club-settings/membership/step2/edit/${res?.data?.id}`)
          }),
          toastMessage()
        );
      }
      // navigate to membership page with section=membership
      
    } catch (error) {}
  };
  // reset form when membership data is fetched
  useEffect(() => {
    if (isSuccess && membershipData) {
      reset(membershipData.data);
    }
  }, [membershipData, isSuccess]);
  // show loader when fetching membership data
  if (isFetching || loadingMembership) {
    return (
      <div className="w-full min-h-dvh justify-center items-center flex">
        <Loader />
      </div>
    );
  }
  // show error message when membership data is not fetched
  if (isError) {
    return <ErrorSection/>;
  }
  return (
   <>
   <div className="flex w-full items-center justify-center gap-4">
      <div className="p-[10px] rounded-full border border-primary"><span className="w-5 h-5 bg-primary rounded-full block"></span></div>
      <div className="w-[155px] h-[3px] bg-[#ccc]">

      </div>
      <div className="p-[10px] rounded-full border bg-[#ccc]"><span className="w-5 h-5 bg-[#ccc] rounded-full block"></span></div>
   </div>
    <div className="flex w-full items-center justify-center gap-4">
      <div className="p-[10px] text-primary">
        Step 1
      </div>
      <div className="w-[130px] ">

      </div>
      <div className="p-[10px]  text-[#ccc] text-center">Step 2</div>
   </div>
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="p-2 w-full flex flex-col gap-12 max-h-[calc(100dvh-250px)] overflow-y-auto customScroll text-start "
    >
      {/* membership info */}
      <MembershipInfo control={control} errors={errors} getValues={getValues} eventType={type} />
      {/* booking privilege */}
      
      {/* membership configurations */}
      <MembershipConfigurations
        control={control}
        eventType={type}
        errors={errors}
        watch={watch}
        setValue={setValue}
        trigger={trigger}
        //courts={courts}
        getValues={getValues}
      />
      {/* membership benefit */}
      {/* <MembershipBenefit
        control={control}
        errors={errors}
        getValues={getValues}
      /> */}
      {/* submit button */}
      <div className="flex pt-2 gap-3 justify-end w-full items-center pr-4 pb-4">
        <Button
          customeStyle=" text-red-500 hover:border hover:border-red-500 p-3 px-2 rounded-full w-[200px] mobile:w-[120px]"
          text={type === 'view'?shared.close:shared.cancel}
          width="150px"
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            navigate("/club-settings/customer?section=membership");
          }}
        />
       {type !== 'view'&& <Button
          customeStyle="bg-primary text-white dark:bg-primaryYellow dark:text-primary p-3 px-2 rounded-full w-[200px] mobile:w-[120px]"
          text={'Next'}
          width="150px"
          type="submit"
        />}
         {type === 'view'&& <Button
          customeStyle="bg-primary text-white dark:bg-primaryYellow dark:text-primary p-3 px-2 rounded-full w-[200px] mobile:w-[120px]"
          text={'Next'}
          width="150px"
          type="button"
          onClick={(e)=>{
            e.preventDefault();
            navigate(`/club-settings/membership/step2/view/${param?.id}`)
          }}
        />}
      </div>
    </form>
   </> 
  );
}

export default MembershipInfoOne;
